import React, { useEffect, useMemo, useRef } from "react";
import { useFilterContext } from "../../../state/FilterContext";
import { useArrayContext } from "../../../state/ArrayContext";
import { useSiteContext } from "../../../state/SiteContext";
import { SourceItem } from "../../../shared/models/source-item.model";
import { services } from "../../../globals";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";

/***
 * Array source that returns all custom property names from metadata on the site that match the filter.
 */
export const CustomPropertyNamesQuery = React.memo(function CustomPropertyNamesQuery(): React.ReactElement {
    const { setArray } = useArrayContext();
    const { siteState } = useSiteContext();
    const { filterState } = useFilterContext();
    const lastRequestSignatureRef = useRef<string | null>(null);

    const memoizedRequest: MetadataRequest = useMemo(() => {
        return { ...filterState };
    }, [filterState]);
    const requestSignature = useMemo(() => {
        if (!siteState.site?.name) {
            return "";
        }
        return JSON.stringify({
            site: siteState.site.name,
            request: memoizedRequest,
        });
    }, [siteState.site?.name, memoizedRequest]);

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            if (siteState.site?.name) {
                if (requestSignature && lastRequestSignatureRef.current === requestSignature) {
                    return;
                }
                lastRequestSignatureRef.current = requestSignature;
                const nameItems: Array<SourceItem> = await services.search.getPropertyNames(
                    siteState.site?.name || "",
                    memoizedRequest,
                );
                const result = nameItems.map((item, ix) => {
                    return { ...item, position: ix + 1 };
                });
                if (isMounted) {
                    setArray(result);
                }
            }
        };
        fetchData();
        return () => { isMounted = false; };
    }, [siteState, setArray, memoizedRequest, requestSignature]);

    return <></>;
});